<template>
    <MultiSelect v-model="text" :options="datas" :optionLabel="caption_name" :optionValue="value_name" :placeholder="placeholder" :scrollHeight="scrollHeight"
    :editable="editable" :showClear="showClear" :loading="loading" :disabled="readonly" :filter="filter" :display="display" />
</template>

<script>
import { computed } from 'vue'
import MultiSelect from 'primevue/multiselect';

export default {
    name: 'tw-multiselect',
    components: {
        MultiSelect
    },
    setup(props, context) {
        const datas = computed(() => {
            return (props.data_source && props.data_source.datas) || []
        })

        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? null : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        return {
            text,
            datas
            // columns,
            // showSummary
        }
    },
    props: {
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        caption_name: {
            type: String,
            default: 'label'
        },
        value_name: {
            type: String,
            default: 'value'
        },
        modelValue: null,
        readonly: Boolean,
        placeholder: String,
        scrollHeight: String,
        editable: Boolean,
        showClear: Boolean,
        loading: Boolean,
        filter: Boolean,
        display: Boolean
    }
}
</script>
<style lang="scss" scoped>
.p-multiselect {
    width: 18rem;
}

::v-deep(.multiselect-custom) {
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: .25rem;
        padding-bottom: .25rem;
    }

    .country-item-value {
        padding: .25rem .5rem;
        border-radius: 3px;
        display: inline-flex;
        margin-right: .5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);

        img.flag {
            width: 17px;
        }
    }
}

@media screen and (max-width: 640px) {
    .p-multiselect {
        width: 100%;
    }
}
</style>